// ** Dropdowns Imports
import IntlDropdown from "./IntlDropdown";
import UserDropdown from "./UserDropdown";
// import NavbarSearch from './NavbarSearch'
import NotificationDropdown from "./NotificationDropdown";

// ** Third Party Components
import { Sun, Moon, Bell } from "react-feather";

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap";
import Point from "./Point";
import AddNew from "./AddNew";
import Help from "./Help";
import ChatMess from "./ChatMess";
import { roleUser } from "../../../../views/apps/ecommerce/utils/utils";

const user = JSON.parse(localStorage.getItem("userData"));
const token = `Bearer ${user?.data?.token}`;
const token_company = localStorage?.getItem("token_company");

//  ** get project id

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props;
  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />;
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    }
  };

  const navButtons = [
    {
      name: "point",
      button: <Point />,
    },
    {
      name: "addNew",
      button: <AddNew />,
    },
    {
      name: "chat",
      button: <ChatMess />,
    },
    {
      name: "language",
      button: <IntlDropdown />,
    },
    {
      name: "themeToggle",
      button: (
        <NavItem className="d-none d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem>
      ),
    },
    {
      name: "notification",
      button: token && token_company && <NotificationDropdown />,
    },
    // {
    //   'name': 'help',
    //   'button': <Help />
    // },
    {
      name: "user",
      button: <UserDropdown />,
    },
  ];

  let showOnlyButtons = [];
  if (roleUser() == "client") {
    showOnlyButtons = ["chat", "language", "themeToggle", "user"];
  }
  // if (token && token_company && roleUser() != 'client'){
  //   showOnlyButtons.push('notification');
  // }

  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      {navButtons.map(({ name, button }) => {
        return (showOnlyButtons.length && showOnlyButtons.includes(name)) ||
          !showOnlyButtons.length ? (
          <li key={name}>{button}</li>
        ) : null;
      })}
      {/* <NavbarSearch /> */}
      {/* <CartDropdown /> */}
      {/* <FakeNotification /> */}
    </ul>
  );
};
export default NavbarUser;

const FakeNotification = () => {
  return <Bell size={21} />;
};
